import * as React from 'react';
import { RouteComponentProps } from '@reach/router';
import { Form as FormikForm, Formik } from 'formik';
import { Form } from 'react-bootstrap-formik';
import Checkbox from 'components/elements/Checkbox';
import * as yup from 'yup';

import LoadingButton from 'components/LoadingButton';
import { apiRequest } from 'admin/api';

interface AdminEmailsPageProps extends RouteComponentProps {}
const AdminEmailsPage: React.FC<AdminEmailsPageProps> = (props) => {
  return (
    <div>
      <h1>Lähetä sähköposteja</h1>
      <SendEmailForm />
    </div>
  );
};

const SendEmailFormValidationSchema = yup
  .object({
    recipients: yup.string(),
    subject: yup.string().required('Syötä sähköpostin aihe'),
    message: yup.string().required('Syötä sähköpostiviesti'),
  })
  .required();
const SendEmailForm = () => {
  const [usersWithoutOrders, setUsersWithoutOrders] =
    React.useState<boolean>(false);
  const [resultMessage, setResultMessage] = React.useState<string | null>(null);
  return (
    <div>
      <Formik
        initialValues={{
          recipients: '',
          subject: '',
          message: '',
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={SendEmailFormValidationSchema}
        onSubmit={async (
          values,
          { setErrors, setStatus, resetForm, setSubmitting },
        ) => {
          setSubmitting(true);
          try {
            const response = await apiRequest('/users/bulk-email/', {
              method: 'POST',
              data: {
                ...values,
                usersWithoutOrders,
              },
            });
            if (response?.success) {
              setResultMessage(
                `Sähköpostit lähetetään ${response.count} vastaanottajalle!`,
              );
            }
          } catch (e) {
            console.error('Error submitting form', e);
            setSubmitting(false);
            setStatus({ success: false });
            alert(e);
            return;
          }
          setSubmitting(false);
          resetForm();
          setUsersWithoutOrders(false);
        }}
      >
        {({ values, isSubmitting, handleChange }) => (
          <FormikForm>
            <Form.Input
              name="recipients"
              label="Vastaanottajan sähköpostit"
              placeholder="(valinnainen)"
            />
            <div className="FilterWithoutOrders">
              <Checkbox
                onChange={() => {
                  setUsersWithoutOrders(!usersWithoutOrders);
                }}
                checked={usersWithoutOrders}
              >
                Käyttäjät, joilla on kuvauksia ilman tilauksia
              </Checkbox>
            </div>
            <Form.Input name="subject" label="Sähköpostin aihe" />
            <Form.Textarea
              name="message"
              label="Sähköpostin sisältö"
              disabled={isSubmitting}
            />
            {!!resultMessage && (
              <div className="mt-3 alert alert-success">{resultMessage}</div>
            )}
            <LoadingButton
              variant="primary"
              type="submit"
              loading={isSubmitting}
            >
              Lähetä sähköposteja
            </LoadingButton>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
};
export default AdminEmailsPage;
